'use strict';

import $ from "jquery";

export default class cvActions {
    constructor(options) {
        this.opt = options;
        this.bindHandlers();
    }

    bindHandlers ()
    {
        var self = this;

        $('.profile-info').on('click', '.f-switch-checkbox', function () {

            let input = $(this).find('input');

            var parentDiv = $(this).closest('.card');

            if (input.is(':checked')) {
                $(parentDiv).removeClass('published').addClass('unpublished');
            } else {
                $(parentDiv).addClass('published').removeClass('unpublished');
            }

            input.attr('disabled', true);

            var cvId = $(this).closest('.cv-card').attr('data-cv-id');

            $.ajax({
                url: self.opt.switchSvStatusUrl + '/' + cvId,
                type: "POST",
                cache: false,
                success: function(data) {
                    if (data.success) {
                        location.reload();
                    }
                    else {
                        console.log(data.message);
                    }
                },
                error: function(e) {
                    console.log('error');
                }
            });
        });

        $('#deleteCvProfileModal').on('click', '.delete-cv', function () {
            var cvId = $(this).attr('data-cv-id');

            $.ajax({
                url: '/delete-entity',
                type: "GET",
                data: {
                    entityName: 'Cv',
                    id: cvId
                },
                cache: false,
                success: function(data) {
                    if (data.success) {
                        location.reload();
                    }
                    else {
                        console.log(data.message);
                    }
                },
                error: function(e) {
                    console.log('error');
                }
            });
        });
    }
}